import * as z from "zod";

export const deleteMetaAdsIntegration = {
  name: "deleteMetaAdsIntegration" as const,
  input: z.null(),
  output: z.object({ success: z.boolean() }),
};
